module.exports = __webpack_public_path__ + "static/media/banner_icon.950de441.png";